/* eslint-disable @typescript-eslint/naming-convention */
import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { downloadResponse, notFoundResponse, okResponse, updatedResponse } from '../../../routes/defaultResponses';

const ObjectTypeFieldValuesSchema = Type.Any();

export const objectPaths = {
    '/api/objects/{objectId}/composition/copyToSimilar': {
        parameters: [createPathGuidParameter('objectId')],
        post: {
            operationId: 'objectControllers.copyCompositionToSimilarObjects',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Intersect([
                                    Type.Object({
                                        id: Type.String(),
                                    }),
                                    Type.Object({
                                        name: Type.String(),
                                    }),
                                ]),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/objects/{objectId}/composition/copyFromObject': {
        parameters: [createPathGuidParameter('objectId')],
        post: {
            operationId: 'objectControllers.copyCompositionFromObject',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            sourceObjectId: Type.String(),
                        }),
                    },
                },
            },
            responses: { ...okResponse },
        },
    },
    '/api/objects/{objectId}/objectTypeFieldsValues': {
        parameters: [createPathGuidParameter('objectId')],
        get: {
            operationId: 'objectControllers.getObjectTypeFieldValues',
            responses: {
                '200': {
                    description: 'Array of object type fields',
                    content: {
                        'application/json': {
                            schema: ObjectTypeFieldValuesSchema,
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            operationId: 'objectControllers.updateObjectTypeFieldValues',
            requestBody: {
                content: {
                    'application/json': {
                        schema: ObjectTypeFieldValuesSchema,
                    },
                },
            },
            responses: {
                ...updatedResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/objects/download/shapeFiles': {
        get: {
            operationId: 'objectControllers.downloadShapeFiles',
            parameters: [
                { name: 'objectName', in: 'query', schema: Type.String() },
                { name: 'objectCode', in: 'query', schema: Type.String() },
                { name: 'companyId', in: 'query', schema: Type.String({ format: 'uuid' }) },
                { name: 'batchId', in: 'query', schema: Type.String({ format: 'uuid' }) },
                { name: 'status', in: 'query', schema: Type.String() },
                { name: 'location', in: 'query', schema: Type.String() },
                { name: 'locationCode', in: 'query', schema: Type.String() },
                { name: 'objectTypeId', in: 'query', schema: Type.String({ format: 'uuid' }) },
                { name: 'attributes', in: 'query', schema: Type.Any() },
                {
                    name: 'labels',
                    in: 'query',
                    schema: Type.Array(Type.String()),
                },
            ],
            responses: {
                ...downloadResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/objects/download/excel': {
        get: {
            operationId: 'objectControllers.downloadExcel',
            parameters: [
                { name: 'languageCode', in: 'query', schema: Type.String(), required: true },
                { name: 'objectName', in: 'query', schema: Type.String() },
                { name: 'objectCode', in: 'query', schema: Type.String() },
                { name: 'companyId', in: 'query', schema: Type.String({ format: 'uuid' }) },
                { name: 'batchId', in: 'query', schema: Type.String({ format: 'uuid' }) },
                { name: 'status', in: 'query', schema: Type.String() },
                { name: 'location', in: 'query', schema: Type.String() },
                { name: 'locationCode', in: 'query', schema: Type.String() },
                { name: 'objectTypeId', in: 'query', schema: Type.String({ format: 'uuid' }) },
                { name: 'attributes', in: 'query', schema: Type.Any() },
                {
                    name: 'labels',
                    in: 'query',
                    schema: Type.Array(Type.String()),
                },
            ],
            responses: {
                ...downloadResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/objects/permissions': {
        get: {
            operationId: 'objectsController.getPermissions',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                canManageLabels: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
